import { PageMetaConfig } from '@spartacus/core'

export const ebPageMetaConfig: PageMetaConfig = {
  pageMeta: {
    resolvers: [
      {
        property: 'title',
        method: 'resolveTitle'
      },
      {
        property: 'heading',
        method: 'resolveHeading'
      },
      {
        property: 'breadcrumbs',
        method: 'resolveBreadcrumbs'
      },
      {
        property: 'description',
        method: 'resolveDescription'
      },
      {
        property: 'robots',
        method: 'resolveRobots'
      },
      {
        property: 'canonicalUrl',
        method: 'resolveCanonicalUrl'
      },
      {
        property: 'alternates',
        method: 'resolveAlternates'
      },
      {
        property: 'structuredData',
        method: 'resolveStructuredProductData'
      },
      {
        property: 'ogpMetaData',
        method: 'resolveOGPMetaData'
      }
    ],
    canonicalUrl: {
      forceHttps: true,
      forceWww: false,
      removeQueryParams: true,
      forceTrailingSlash: false
    }
  }
}
